import { render, staticRenderFns } from "./phone-verification.component.vue?vue&type=template&id=21058181"
import script from "./phone-verification.component.ts?vue&type=script&lang=ts&external"
export * from "./phone-verification.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21058181')) {
      api.createRecord('21058181', component.options)
    } else {
      api.reload('21058181', component.options)
    }
    module.hot.accept("./phone-verification.component.vue?vue&type=template&id=21058181", function () {
      api.rerender('21058181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/phone-verification/phone-verification.component.vue"
export default component.exports